import darkTokens from './tokens/wc-theme-dark';
import resetStyles from './reset/wc-theme-reset';
import { baseStyles } from './base/base-styles';
export const styles = [
    resetStyles,
    darkTokens,
    baseStyles
];
